import React from "react";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import { CACHE_RELEASE_APP_OS } from "src/constants/actionCache";
import ReleaseOSPopup from "../Popup/ReleaseOSPopup";
import ShowCacheReleaseAppOS from "../ShowCache/ShowCacheReleaseAppOS";

const ReleaseOSControlPanel = ({
  children,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Operating System"
          isShowButton={isShowCache(currentActionCache, CACHE_RELEASE_APP_OS)}
        >
          <ShowCacheReleaseAppOS
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>

        <ReleaseOSPopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default ReleaseOSControlPanel;
